module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBold.d1c7f0c6.eot";